import { TFunction } from 'i18next';

import { UserStatus } from '@/api/auth';
import { findGroup } from '@/helpers/cms';
import { CurrencyCode } from '@/helpers/currency';
import { USER_GROUP } from '@/helpers/user';

export const groups = [
  USER_GROUP.GOLD,
  USER_GROUP.PLATINUM,
  USER_GROUP.DIAMOND,
];

enum VipGroups {
  VIP1 = 'VIP1',
  VIP2 = 'VIP2',
  VIP3 = 'VIP3',
}

export enum VipGroupName {
  GOLDEN = 'GOLD',
  PLATINUM = 'PLATINUM',
  DIAMOND = 'DIAMOND',
}

export const getUserVipGroup = (statuses: UserStatus[]) => {
  const findVipGroup = findGroup(statuses);

  if (findVipGroup(VipGroups.VIP3)) return VipGroupName.DIAMOND;
  if (findVipGroup(VipGroups.VIP2)) return VipGroupName.PLATINUM;
  if (findVipGroup(VipGroups.VIP1)) return VipGroupName.GOLDEN;

  return;
};

const upgradeVipPrices: Record<string, number> = {
  // fiat
  [CurrencyCode.AUD]: 1000,
  [CurrencyCode.CAD]: 1000,
  [CurrencyCode.EUR]: 1000,
  [CurrencyCode.USD]: 1000,
  [CurrencyCode.NZD]: 1000,
  [CurrencyCode.NOK]: 10000,

  // crypto
  [CurrencyCode.USDT]: 1000,
  [CurrencyCode.BTC]: 0.037,
  [CurrencyCode.BCH]: 4.5,
  [CurrencyCode.LTC]: 15,
  [CurrencyCode.ETH]: 0.6,
  [CurrencyCode.DOG]: 15000,
  [CurrencyCode.JPY]: 150000,
  [CurrencyCode.BRL]: 2000,
  [CurrencyCode.ZAR]: 10000,
};

export const getUpgradeVipPrice = (userCurrencyCode: string) => {
  return upgradeVipPrices[userCurrencyCode];
};

export const getPercentBreakpoins = (
  t: TFunction,
  userVipLevel?: VipGroupName
) => {
  return [
    {
      tooltip: t('progress.booster'),
      icon: '/vip/vip-page/progress-bar/booster.webp',
      percentage: 1,
    },
    {
      tooltip: t('progress.booster'),
      icon: '/vip/vip-page/progress-bar/booster.webp',
      percentage: 25,
    },
    {
      tooltip: t('progress.vipSecured'),
      icon: `/vip/vip-page/progress-bar/${userVipLevel?.toLowerCase()}-card.webp`,
      boosted: true,
      percentage: 50,
    },
    {
      tooltip: t('progress.booster'),
      icon: '/vip/vip-page/progress-bar/booster.webp',
      percentage: 75,
    },
    {
      tooltip: t('progress.superSpotBooster'),
      icon: '/vip/vip-page/progress-bar/super-card.webp',
      percentage: 100,
    },
  ];
};
